import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Departments Redux States
import {
  GET_DEPARTMENTS,
  CREATE_DEPARTMENTS,
  GET_DEPARTMENT,
  EDIT_DEPARTMENT,
  DELETE_DEPARTMENT,
} from "./actionTypes";
import {
  loadDepartments,
  apiError,
  createdDepartment,
  setDepartment,
  editDepartmentSuccess,
  deleteDepartmentSuccess,
} from "./actions";
//Include Both Helper File with needed methods
import axios from "axios";

function* getDepartments({ payload: { page, qnt, name, email, slug } }) {
  try {
    const response = yield call(
      axios.get,
      `/department?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (email ? `&email=${email}` : "") +
        (slug ? `&slug=${slug}` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadDepartments(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* createDepartment({ payload: { newDepartmentValues } }) {
  try {
    const response = yield call(axios.post, "/department", newDepartmentValues);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      let message = response.data.message;
      yield put(createdDepartment(newDepartmentValues, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getDepartment({ payload: { idDepartment } }) {
  try {
    const response = yield call(
      axios.get,
      `/department${idDepartment ? `?id=${idDepartment}` : ""}`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setDepartment(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editDepartment({ payload: { idDepartment, newDepartmentValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/department${idDepartment ? `?id=${idDepartment}` : ""}`,
      newDepartmentValues
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editDepartmentSuccess({ newDepartmentValues, message }));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteDepartment({ payload: { idDepartment } }) {
  try {
    const response = yield call(
      axios.delete,
      `/department${idDepartment ? `?id=${idDepartment}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteDepartmentSuccess(idDepartment, message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 401:
          message = "Your session has expired";
          break;
        case 404:
          message = "Department not found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchDepartment() {
  yield takeEvery(GET_DEPARTMENTS, getDepartments);
}
export function* watchCreateDepartment() {
  yield takeEvery(CREATE_DEPARTMENTS, createDepartment);
}
export function* watchGetDepartment() {
  yield takeEvery(GET_DEPARTMENT, getDepartment);
}
export function* watchEditDepartment() {
  yield takeEvery(EDIT_DEPARTMENT, editDepartment);
}
export function* watchDeleteDepartment() {
  yield takeEvery(DELETE_DEPARTMENT, deleteDepartment);
}
function* authSaga() {
  yield all([
    fork(watchDepartment),
    fork(watchCreateDepartment),
    fork(watchGetDepartment),
    fork(watchEditDepartment),
    fork(watchDeleteDepartment),
  ]);
}

export default authSaga;
